import { Link } from 'react-router';

import styled from '@emotion/styled';

import { CUSTOMERS } from '../../../routes/routeConstants';
import { formatPhone } from '../../../utils/utils';

interface CustomerLinkCellProps {
  data?: Record<string, any>;
  dataKey?: string;
}

// A customer's number that opens their page. It stops the click so the row's
// own detail slider doesn't open as well.
const CustomerLinkCell: React.FC<CustomerLinkCellProps> = ({ data, dataKey = 'chat_id' }) => {
  const chatId = data?.[dataKey];
  if (!chatId) return <>—</>;
  return (
    <CustomerLink
      to={`/${CUSTOMERS}/${chatId}`}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
      title='Open customer'
    >
      {formatPhone(chatId)}
    </CustomerLink>
  );
};

export default CustomerLinkCell;

const CustomerLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  font-variant-numeric: tabular-nums;
  border-bottom: 1px dashed #c9c4b6;

  &:hover {
    color: var(--ok);
    border-bottom-color: var(--ok);
  }
`;
